// application/frontend/src/App.js
import React, { useEffect } from 'react';
//import { useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container } from 'react-bootstrap';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Cancel from './pages/Cancel';
import Store from './pages/Store';
import Success from './pages/Success';
import LocationChooser from './pages/LocationChooser';
import RegistrationForm from './pages/RegistrationForm';

import CartProvider from './CartContext';
import CheckoutMbWay from './components/CheckoutMbWay';
import { LocationProvider } from './LocationContext';

import { backend } from './authConfig';

function App() {
  //const [status, setStatus] = useState(null);
  if (process.env.NODE_ENV)
    console.log('Environment:', process.env.NODE_ENV);

  const fName = "App";
  const logPrefix = `<${fName}>`;
  console.log(`${logPrefix} backend.ping:`, backend.ping)

  const pingBackends = async () => {
    const fName = "App.pingBackends";
    const logPrefix = `<${fName}>`;
    
    console.log(`${logPrefix} Pinging all backend endpoints...`);

    // ping backend /api/ping
    fetch(`${backend.ping}`)
    .then((response) => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.text();
    })
    .then((data) => {
        console.log(`${logPrefix} ping response:`, data);
    })
    .catch((error) => {
        console.error(`${logPrefix} Error pinging main backend:`, error);
    });

    // ping submit form contract endpoint
    fetch(`${backend.ping_submit_form_contract}`, {
      method: 'POST',
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then((data) => {
      console.log(`${logPrefix} submit_form_contract ping response:`, data);
    })
    .catch((error) => {
      console.error(`${logPrefix} Error pinging submit_form_contract:`, error);
    });

    // ping POST backend /api/v2/payrequest/ping
    fetch(`${backend.ping_post_payrequest}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then((data) => {
      console.log(`${logPrefix} post_payrequest ping response:`, data);
    })
    .catch((error) => {
      console.error(`${logPrefix} Error pinging post_payrequest:`, error);
    });
  
    // ping GET backend /api/v2/payrequest/ping
    fetch(`${backend.ping_get_payrequest}`, {
      method: 'GET',
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then((data) => {
      console.log(`${logPrefix} get_payrequest ping response:`, data);
    })
    .catch((error) => {
      console.error(`${logPrefix} Error pinging get_payrequest:`, error);
    });
  };

  useEffect(() => {
    // Initial ping when component mounts
    pingBackends();
    
    // Set up interval to ping every 30 seconds (30000 milliseconds)
    const pingInterval = setInterval(() => {
      pingBackends();
    }, 30000);
    
    // Cleanup interval when component unmounts
    return () => {
      clearInterval(pingInterval);
    };
  }, []);

  // Check if status has been loaded
  //if (!status) {
  //  return <div>Loading...</div>;
  //}

  // Check if the system is under maintenance
  //if (status.status_code === 0) {
  //  console.log(`${logPrefix} status_code:`, status.status_code)
  //  return <div>O sistema está em manutenção. Tente mais tarde</div>;
  //} else 
  
  return (
    <CartProvider>
      <LocationProvider>
        <Container>
          <BrowserRouter>
          <Routes>
            <Route index element={<LocationChooser />} />
            <Route path="/store" element={<Store />} />
            <Route path="/success" element={<Success />} />
            <Route path="/cancel" element={<Cancel />} />
            <Route path="/registo" element={<RegistrationForm />} />
            <Route path="/location/:locationId" element={<Store />} />
            <Route path="/checkout-mbway/:locationId/:productNumber" element={<CheckoutMbWay />} />
          </Routes>
          </BrowserRouter>
        </Container>
      </LocationProvider>
    </CartProvider>
  );
}

export default App;
